import routeMap from "../app/routes.js";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import { matchPath } from "react-router-dom";
const getRouteName = (pathname) => {
    if (!window || !window.location)
        return "";
    for (const route of routeMap({
        isMobile: window?.__GLOBAL_CONTEXT__?.userAgent?.isMobile,
        isNewFlightDetailsPage: !!window?.__GLOBAL_CONTEXT__?.isNewFlightDetailsPage,
        isNewFlightDetailsDesktopPage: !!window?.__GLOBAL_CONTEXT__?.isNewFlightDetailsDesktopPage,
        isPaymentCollectionPage: !!isFeatureRunningClientSide("FLIGHTS_WEB_PAYMENT_COLLECTION_NEW_PAGE"),
        isWebview: window?.__GLOBAL_CONTEXT__?.userAgent?.isWebview
    })) {
        if (matchPath(pathname, { path: route.path, exact: true })) {
            return route.name;
        }
    }
    return "";
};
export default getRouteName;
